import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { PopulateCartLineData } from "@sunSource/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, CartLineCollectionModel, CartLineCollectionModel>;

export const CustomExecuteOnSuccessCallback: HandlerType = props => {
    PopulateCartLineData(props.apiResult.cartLines)
    props.parameter.onSuccess?.();
};

replaceInChain(chain, ExecuteOnSuccessCallback, CustomExecuteOnSuccessCallback)
